import React from 'react';
import { withTranslation } from "react-i18next";
import {Link} from "react-router-dom";

let ToOverviewComponent = ({t}) => {return <Link to={'/'} className="a-text">
		<span className="arrow-right"/>
		<span className="a-text-content">{t('navigation.backToOverview')}</span>
	</Link>;};


export default withTranslation() (ToOverviewComponent)